import React, { useState, useEffect } from 'react';
import axios from 'axios';

const MapelManager = ({ token }) => {
  const [mapelList, setMapelList] = useState([]);
  const [namaMapel, setNamaMapel] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => { fetchMapel(); }, [token]);

  const fetchMapel = async () => {
    try {
      const res = await axios.get('https://sijapan.sman10fajarharapan.sch.id/api/mapel', { headers: { Authorization: `Bearer ${token}` } });
      setMapelList(res.data);
    } catch (err) { console.error(err); }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!namaMapel) return;
    setLoading(true);
    try {
      await axios.post('https://sijapan.sman10fajarharapan.sch.id/api/mapel', { nama_mapel: namaMapel }, { headers: { Authorization: `Bearer ${token}` } });
      setNamaMapel('');
      fetchMapel(); 
      alert('Mapel berhasil ditambahkan!');
    } catch (err) { alert('Gagal simpan. Mungkin nama mapel sudah ada.'); }
    setLoading(false);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Yakin hapus mapel ini?')) return;
    try {
      await axios.delete(`https://sijapan.sman10fajarharapan.sch.id/api/mapel/${id}`, { headers: { Authorization: `Bearer ${token}` } });
      fetchMapel();
    } catch (err) { alert('Gagal hapus.'); }
  };

  return (
    <div style={{ paddingBottom: '50px' }}>
      <div style={{ marginBottom: '25px' }}>
        <h2 style={{ margin: 0, color: '#1e293b' }}>📚 Data Mata Pelajaran</h2>
      </div>
      <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
        <div style={{ flex: 1, minWidth: '300px' }}>
          <div style={{ background: 'white', padding: '25px', borderRadius: '12px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)', border: '1px solid #e2e8f0' }}>
            <h3 style={{ marginTop: 0, fontSize: '16px', color: '#334155' }}>Tambah Mapel Baru</h3>
            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: '15px' }}>
                <label style={{ display: 'block', fontWeight: '600', fontSize: '13px', marginBottom: '8px', color: '#64748b' }}>Nama Mata Pelajaran</label>
                <input type="text" value={namaMapel} onChange={(e) => setNamaMapel(e.target.value)} placeholder="Contoh: Biologi Lintas Minat" required />
              </div>
              <button type="submit" disabled={loading} style={{ width: '100%', padding: '12px', background: '#4361ee', color: 'white', border: 'none', borderRadius: '8px', fontWeight: '600' }}>{loading ? 'Menyimpan...' : '+ Simpan Mapel'}</button>
            </form>
          </div>
        </div>
        <div style={{ flex: 2, minWidth: '300px' }}>
          <div style={{ background: 'white', borderRadius: '12px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)', overflow: 'hidden', border: '1px solid #e2e8f0' }}>
            <table style={{ margin: 0 }}>
              <thead><tr><th width="50">No</th><th>Nama Mata Pelajaran</th><th width="100" style={{ textAlign: 'center' }}>Aksi</th></tr></thead>
              <tbody>
                {mapelList.map((m, idx) => (
                  <tr key={m.id}>
                    <td style={{ textAlign: 'center', color: '#64748b' }}>{idx + 1}</td>
                    <td style={{ fontWeight: '600', color: '#0f172a' }}>{m.nama_mapel}</td>
                    <td style={{ textAlign: 'center' }}>
                      <button onClick={() => handleDelete(m.id)} style={{ background: '#fee2e2', color: '#ef4444', padding: '6px 12px', borderRadius: '6px', fontSize: '12px', fontWeight: '600', border: 'none' }}>Hapus</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MapelManager;